import { TFunction } from 'i18next'

import { getCountryTaxFieldData } from '../../../../../../../utils/getCountryTaxFieldData'

interface GetCustomerVatNoFieldConfigResult {
  errorRequired: string
  label: string
  placeholder: string
}

const defaultVatNoLabel = 'VAT'

export const getCustomerVatNoFieldConfig = (
  countryId: string | undefined,
  t: TFunction,
): GetCustomerVatNoFieldConfigResult => {
  const vatNo = getCountryTaxFieldData(countryId)?.vatNo
  const label = vatNo?.label ?? defaultVatNoLabel
  const formatExample = vatNo?.formatExample

  return {
    label,
    placeholder: formatExample
      ? t('external_invoices.missing_customer_compliance_details.modal.form.field.vat_number.placeholder', {
          example: formatExample,
        })
      : '',
    errorRequired: t(
      'external_invoices.missing_customer_compliance_details.modal.form.field.vat_number.error.required',
      { fieldName: label },
    ),
  }
}
